import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, withRouter } from "react-router-dom";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import { toast } from "react-toastify";
import "./Favorite.scss";
import { BinocularIcon, HeartIconFilled } from "../../shared/component/svg/Icons";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import LoadingComponent from "../../shared/component/LoadingComponent/LoadingComponent";
import { CareerCard, CollegeCard, MajorCard, ScholarshipCard } from "../../shared/component/Card/Card";
import { Nav, Tab } from "react-bootstrap";
import NoContentComponent from "../../shared/component/NoContentComponent/NoContentComponent";
import { formatString } from "../../shared/utils/string";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";

let TABNAME = {
	COLLEGE: "#kampus",
	MAJOR: "#jurusan",
	CAREER: "#karir",
	SCHOLARSHIP: "#beasiswa",
};
let TABNAME_TO_CONST = {
	"#kampus": "college",
	"#jurusan": "major",
	"#karir": "career",
	"#beasiswa": "scholarship",
};
const TAB_OPT = [
	{ id: TABNAME.COLLEGE, name: Variable.COLLEGE },
	{ id: TABNAME.MAJOR, name: Variable.MAJOR },
	{ id: TABNAME.CAREER, name: Variable.CAREER },
	{ id: TABNAME.SCHOLARSHIP, name: Variable.SCHOLARSHIP },
];

const Favorite = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, ...props }) => {
	let location = useLocation();
	const [selectedTab, setSelectedTab] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [favorites, setFavorites] = useState(null);
	const [favCount, setFavCount] = useState(null);

	// If not authenticated, redirect to the home page
	useEffect(() => {
		if (!isAuthenticated) {
			props.history.push(RoutePath.ROOT);
		}
	}, [isAuthenticated]); // eslint-disable-line

	// For every favorite URL change, we want to update the selected tab
	useEffect(() => {
		if (location?.pathname?.includes(RoutePath.FAVORITE)) {
			setSelectedTab(
				Object.values(TABNAME).includes(location?.hash.split("?")[0])
					? props.history.location?.hash.split("?")[0]
					: TABNAME.COLLEGE
			);
		}
	}, [location]); // eslint-disable-line

	// For every tab change, we call the API to update the favorite listings
	useEffect(() => {
		if (selectedTab) {
			getFavorites();
		}
	}, [selectedTab]); // eslint-disable-line

	// Get favorites data
	const getFavorites = async () => {
		setIsLoading(true);
		let res = await makeRequest(
			generateRequestOptions("favoriteList", { queryParams: { category: TABNAME_TO_CONST?.[selectedTab] } })
		);
		if (res.code === 200) {
			setFavorites(res.data);
			setFavCount(res.fav_counts);
		} else {
			toast.error(res.message || Variable.SOMETHING_WENT_WRONG_TRY_AGAIN[ENV_NAME]);
		}
		setIsLoading(false);
	};

	return (
		<div className="container favorite-page">
			<nav aria-label="breadcrumb">
				<ol className="breadcrumb">
					<li className="breadcrumb-item">{Variable.HOME[ENV_NAME]}</li>
					<li className="breadcrumb-item active">{Variable.FAVORITE[ENV_NAME]}</li>
				</ol>
			</nav>
			<Tab.Container onSelect={(k) => setSelectedTab(k)} activeKey={selectedTab}>
				<Nav className="nav-tabs-custom">
					{TAB_OPT?.map((i) => (
						<Nav.Item key={i?.id}>
							<div className={selectedTab !== i?.id ? "h-100 cursorPointer" : "h-100"}>
								<Nav.Link
									href={i?.id}
									className="nav-custom"
									eventKey={i?.id}
									disabled={selectedTab === i?.id}
								>
									{`${i?.name?.[ENV_NAME]} (${favCount?.[TABNAME_TO_CONST?.[i?.id]] || 0})`}
								</Nav.Link>
							</div>
						</Nav.Item>
					))}
				</Nav>
				<Tab.Content className="tab-content-custom">
					{isLoading ? (
						<LoadingComponent notFullScreen className="my-xl" />
					) : !isLoading && favorites?.length > 0 ? (
						<div className="fav-card-cont">
							{favorites?.map((i, idx) => {
								let pr = {
									isLoading: isLoading,
									data: i?.isLoading
										? undefined
										: { ...i?.item, is_favourite: true, fav_obj_id: i?.id },
									onClickFavorite: () => {
										if (i?.isLoading || fetchingAddRemoveFavorites) return;
										props.addRemoveFavorite(
											"remove",
											TABNAME_TO_CONST?.[selectedTab],
											i?.id,
											(res) => getFavorites()
										);
									},
									onClick: () => {},
									ENV_NAME: ENV_NAME,
								};
								switch (selectedTab) {
									case TABNAME.COLLEGE: {
										return (
											<Link
												to={RoutePath.COLLEGE_DETAIL + "/" + i?.item?.id}
												key={i?.id || idx}
												className="text-decoration-none text-label-dark-gray-2"
											>
												<CollegeCard {...pr} />
											</Link>
										);
									}
									case TABNAME.MAJOR: {
										return (
											<Link
												to={RoutePath.MAJOR_DETAIL + "/" + i?.item?.id}
												key={i?.id || idx}
												className="text-decoration-none text-label-dark-gray-2"
											>
												<MajorCard {...pr} />
											</Link>
										);
									}
									case TABNAME.CAREER: {
										return (
											<Link
												to={RoutePath.CAREER_DETAIL + "/" + i?.item?.id}
												key={i?.id || idx}
												className="text-decoration-none text-label-dark-gray-2"
											>
												<CareerCard {...pr} />
											</Link>
										);
									}
									case TABNAME.SCHOLARSHIP: {
										return (
											<Link
												to={RoutePath.SCHOLARSHIP_DETAIL + "/" + i?.item?.id}
												key={i?.id || idx}
												className="text-decoration-none text-label-dark-gray-2"
											>
												<ScholarshipCard {...pr} />
											</Link>
										);
									}
									default:
										return <></>;
								}
							})}
						</div>
					) : (
						// No content
						<NoContentComponent
							className="my-xl"
							icon={<BinocularIcon className="mb-med" />}
							title={formatString(
								Variable.NO_FAVORITE_TITLE[ENV_NAME],
								TAB_OPT?.find((i) => selectedTab === i?.id)?.name?.[ENV_NAME]?.toLowerCase()
							)}
							description={
								<>
									<div className="mb-md">
										{formatString(
											Variable.NO_FAVORITE_DESC[ENV_NAME],
											TAB_OPT?.find((i) => selectedTab === i?.id)?.name?.[ENV_NAME]?.toLowerCase()
										)}
										<HeartIconFilled width="2rem" height="2rem" className="ms-xs" fill="#F24822" />
									</div>
									<Link
										to={
											selectedTab === TABNAME.COLLEGE
												? RoutePath.COLLEGE
												: selectedTab === TABNAME.MAJOR
												? RoutePath.MAJOR
												: selectedTab === TABNAME.CAREER
												? RoutePath.CAREER
												: selectedTab === TABNAME.SCHOLARSHIP
												? RoutePath.SCHOLARSHIP
												: ""
										}
										className="text-decoration-none"
									>
										<button className="btn btn-cta-primary">
											{formatString(
												Variable.GENERAL_PAGE[ENV_NAME],
												TAB_OPT?.find((i) => selectedTab === i?.id)?.name?.[
													ENV_NAME
												]
											)}
										</button>
									</Link>
								</>
							}
						/>
					)}
				</Tab.Content>
			</Tab.Container>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(Favorite));
